import actions from 'redux/actions'
import { constants, links, mixpanel } from 'common/helpers'
import { getNavFromStructure, getTrackingEventToNavItem } from 'helpers/getters'
import getMakeupTypes from 'helpers/getters/getCosmeticsTypes/getMakeupTypes'
import getSkincareTypes from 'helpers/getters/getCosmeticsTypes/getSkincareTypes'
import getPersonalCareTypes from 'helpers/getters/getCosmeticsTypes/getPersonalCareTypes'

import messages from './messages'


const modifyCosmeticsCategories = (categories) => categories.map(({ subCategories, ...rest }) => ({ ...rest, subNav: subCategories }))

const createEvent = (item, isSubNav) => getTrackingEventToNavItem(item, {
  snowplowEvent: isSubNav
    ? constants.snowplowEvents.burgerMenuInsideClick
    : constants.snowplowEvents.burgerMenuLinkClick,
})

const addEvents = (nav, isSubNav) => nav.map((item) => {
  const newItem = createEvent({ ...item, userLoggedIn: 'yes' }, isSubNav)

  if (Array.isArray(item.subNav)) {
    newItem.subNav = addEvents(item.subNav, true)
  }

  return newItem
})

const getNav = (options) => {
  const {
    notEmptyTypes,
    structure,
    navigation,
    isSubscriptionCancelled,
    resubscribeBurgerMenuAbValue,
    isCollectionsEnabled,
    isIncubatorNeonHeatEnabled,
    isResubscribeMembershipPageEnabled,
    isFatherDayBambooGiftSetEnabled,
    isPopularInStatesHidden,
    isFragranceFinderHidden,
    isFragranceHoroscopeHidden,
    isGiftsHidden,
    isSeparateWellnessEnabled,
  } = options

  const isNewSkincareStructureEnabled = Boolean(structure && structure.skincare)
  const isSeparateWellnessVisible = Boolean(isSeparateWellnessEnabled && structure && structure.wellness)

  let nav = []

  if (isResubscribeMembershipPageEnabled && isSubscriptionCancelled) {
    if (resubscribeBurgerMenuAbValue === 'a') {
      nav.push({
        title: messages.resubscribe,
        to: links.resubscribe,
        iconName: 'resubscribe',
        onClick: () => mixpanel.track(constants.analyticsEvents.resubscribeButton, {
          placement: 'burger menu',
        }),
        dataTestId: 'resubscribe',
      })
    }
    else if (resubscribeBurgerMenuAbValue === 'b') {
      nav.push({
        title: messages.whatIsNew,
        to: links.membership,
        iconName: 'gifts',
        onClick: () => mixpanel.track(constants.analyticsEvents.membershipButtonClick, {
          placement: 'burger menu',
        }),
        dataTestId: 'whatIsNew',
      })
    }
    else if (resubscribeBurgerMenuAbValue === 'c') {
      nav.push({
        title: messages.reasonsToResubscribe,
        to: links.membership,
        iconName: 'resubscribe',
        onClick: () => mixpanel.track(constants.analyticsEvents.membershipButtonClick, {
          placement: 'burger menu',
        }),
        dataTestId: 'reasonsToResubscribe',
      })
    }
  }
  else if (isIncubatorNeonHeatEnabled) {
    nav.push({
      title: messages.rateNeonHeatKit,
      to: links.incubator.neonHeat,
      iconName: 'lightning',
      dataTestId: 'rateNeonHeatKit',
    })
  }
  else {
    nav.push({
      title: messages.earnFreeFragrance,
      to: links.invite,
      iconName: 'free',
      onClick: () => mixpanel.track(constants.analyticsEvents.shareLinkClick, {
        placement: 'mobile menu dropdown',
      }),
      dataTestId: 'earnFreeFragrance',
    })
  }

  nav.push(
    {
      title: messages.myQueue,
      to: links.queue,
      iconName: 'queue',
      dataTestId: 'queue',
    },
    {
      title: messages.tracking,
      to: links.tracking,
      iconName: 'tracking',
      dataTestId: 'tracking',
    },
  )

  nav.push(
    {
      title: messages.catalog,
      isSeparator: true,
    },
    {
      title: messages.main,
      dataTestId: constants.testIds.headerSubNav.main,
      iconName: 'home',
      subNav: [
        { title: messages.men, to: links.subscription.mainMen, dataTestId: constants.testIds.headerSubNav.men },
        { title: messages.women, to: links.subscription.mainWomen, dataTestId: constants.testIds.headerSubNav.women },
      ],
    }
  )

  nav.push({
    title: messages.fineFragrance,
    dataTestId: constants.testIds.headerSubNav.fineFragrance,
    iconName: 'fragrances',
    subNav: (() => {
      const subNav = [
        { title: messages.perfumes, to: links.subscription.perfumes, dataTestId: constants.testIds.headerSubNav.perfumes },
        { title: messages.colognes, to: links.subscription.colognes, dataTestId: constants.testIds.headerSubNav.colognes },
        { title: messages.recommendations, to: links.subscription.recommendations, dataTestId: constants.testIds.headerSubNav.recommendations },
      ]

      if (!isPopularInStatesHidden) {
        subNav.push({ title: messages.fragranceByState, to: links.popularInStates, dataTestId: 'fragranceByState' })
      }

      if (isCollectionsEnabled) {
        subNav.push(
          {
            title: messages.collectionsWomen,
            to: links.subscription.collectionsWomen,
            dataTestId: constants.testIds.headerSubNav.collectionsWomen,
            onClick: () => {
              actions.misc.cookies.setSessionItem(constants.cookieNames.collectionsClickPlacement, 'mobile navigation')
            },
            subNav: navigation.fragrances.collectionsWomen,
          },
          {
            title: messages.collectionsMen,
            to: links.subscription.collectionsMen,
            dataTestId: constants.testIds.headerSubNav.collectionsMen,
            onClick: () => {
              actions.misc.cookies.setSessionItem(constants.cookieNames.collectionsClickPlacement, 'mobile navigation')
            },
            subNav: navigation.fragrances.collectionsMen,
          },
        )
      }

      subNav.push(
        { title: messages.perfumeOfTheMonth, to: links.subscription.currPerfumeOfTheMonth, dataTestId: 'perfumeOfTheMonth' },
        { title: messages.cologneOfTheMonth, to: links.subscription.currCologneOfTheMonth, dataTestId: 'cologneOfTheMonth' },
        { title: messages.extras, to: links.subscription.extras, dataTestId: constants.testIds.headerSubNav.extras },
      )

      if (!isFragranceHoroscopeHidden) {
        subNav.push({
          title: messages.fragranceHoroscope,
          to: links.horoscope,
          dataTestId: constants.testIds.headerSubNav.horoscope,
          subNav: constants.zodiacList.map((zodiacName) => ({
            title: messages.horoscope[zodiacName],
            to: `${links.horoscope}/${zodiacName}`,
            dataTestId: zodiacName,
          })),
        })
      }

      if (!isFragranceFinderHidden) {
        subNav.push({ title: messages.fragranceFinder, to: links.fragranceFinder, dataTestId: 'fragranceFinder' })
      }

      return subNav
    })(),
  })

  nav.push(
    // MAKEUP
    {
      title: messages.makeup,
      iconName: 'makeup',
      dataTestId: constants.testIds.headerSubNav.makeup,
      subNav: [
        { title: messages.seeAll, to: links.makeup, dataTestId: constants.testIds.headerSubNav.allMakeup },
        ...(modifyCosmeticsCategories(getMakeupTypes({ notEmptyTypes, withoutAll: true }))),
      ],
    },
    // SKINCARE
    {
      title: messages.skincare,
      iconName: 'skincare',
      dataTestId: 'skincare',
      subNav: isNewSkincareStructureEnabled
        ? getNavFromStructure({ structure: structure.skincare, root: 'skincare', isMobileNew: true, collections: navigation.skincare })
        : [
          { title: messages.seeAll, to: links.skincare, dataTestId: constants.testIds.headerSubNav.allSkincare },
          {
            title: messages.collectionsForWomen,
            to: links.skincareCollectionWomen,
            dataTestId: constants.testIds.headerSubNav.collectionsForWomen,
            subNav: navigation.skincare.collectionsWomen,
          },
          {
            title: messages.collectionsForMen,
            to: links.skincareCollectionMen,
            dataTestId: constants.testIds.headerSubNav.collectionsForMen,
            subNav: navigation.skincare.collectionsMen,
          },
          ...(modifyCosmeticsCategories(getSkincareTypes({ notEmptyTypes, withoutAll: true }))),
        ],
    },
  )

  if (isSeparateWellnessVisible) {
    nav.push({
      title: messages.wellness,
      iconName: 'wellness',
      dataTestId: 'wellness',
      subNav: getNavFromStructure({ structure: structure.wellness, root: 'wellness', isMobileNew: true }),
    })
  }

  nav.push(
    // PERSONAL CARE
    {
      title: messages.personalCare,
      iconName: 'personalCare',
      dataTestId: 'personalCare',
      subNav: [
        { title: messages.seeAll, to: links.personalCare, dataTestId: constants.testIds.headerSubNav.allPersonalCare },
        ...(modifyCosmeticsCategories(getPersonalCareTypes({ notEmptyTypes, withoutAll: true }))),
      ],
    },
    // CANDLES
    {
      title: messages.candles,
      to: links.candles,
      iconName: 'candles',
      dataTestId: constants.testIds.headerSubNav.candles,
      // subNav: [
      //   { title: messages.scentedCandles, to: links.candles, dataTestId: constants.testIds.headerSubNav.candles },
      // ],
    },
    // GIFTS
    {
      title: messages.gifts,
      iconName: 'gifts',
      dataTestId: constants.testIds.headerSubNav.gifts,
      subNav: [
        ...(
          isFatherDayBambooGiftSetEnabled ? [
            { title: messages.fathersDay, to: links.fathersDayGiftSet, dataTestId: 'fatherDayGiftSet' },
          ] : []
        ),
        { title: messages.seeAll, to: links.gifts, dataTestId: constants.testIds.headerSubNav.gifts },
        { title: messages.giftCard, to: links.giftCard, dataTestId: constants.testIds.headerSubNav.giftCard },
        ...(
          !isGiftsHidden ? [
            { title: messages.giftSetsMen, to: links.giftSetsMen, dataTestId: constants.testIds.headerSubNav.giftSetsMen },
            { title: messages.giftSetsWomen, to: links.giftSet, dataTestId: constants.testIds.headerSubNav.giftSet },
          ] : []
        ),
        { title: messages.skincareSets, to: links.skincareSets, dataTestId: constants.testIds.headerSubNav.skincareSets },
        { title: messages.giftSubscription, toOLD: links.gift, dataTestId: constants.testIds.headerSubNav.giftSubscription },
      ],
    }
  )

  nav.push(
    {
      isSeparator: true,
    },
    {
      title: messages.help,
      toTab: links.faq,
      id: 'faq',
      iconName: 'help',
      onClick: () => mixpanel.track(constants.analyticsEvents.faqLinkClick, { placement: 'header' }),
      dataTestId: 'help',
    }
  )

  return addEvents(nav)
}


export default getNav
